/*
    Description: terms class
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/

// class
class Terms{

    // constructor
    constructor({

        // add selectors
        ulClass = "termsrow__ul",
        liHeaderClass = "termsrow__ul__li__header",
        liContentClass = "termsrow__ul__li__wrapper",
        liImgClass = "termsrow__ul__li__wrapper__img",
        arrowClass = "--js-term-init",
        hideClass = "--js-hide",

    } = {}){

        // get ul
        this.ul = document.querySelector(`.${ulClass}`);

        // get li header
        this.li = (this.ul) ? this.ul.querySelectorAll(`.${liHeaderClass}`) : null;
        
        // get header class
        this.headerClass = liHeaderClass; 

        // get content
        this.contentClass = liContentClass,

        // get image wrapper class
        this.imgClass = liImgClass,

        // get arrow class
        this.arrowClass = arrowClass; 

        // get hide class
        this.hideClass = hideClass;

        // run evnts
        this.events();

    }

    // run all events
    events(){
        
        // end case
        if((!this.ul) || (!this.li)) return;

        // click event
        for(const li of this.li){

            // add event listner
            li.addEventListener("touchstart", this.click.bind(this), {passive:false});
            li.addEventListener("click", this.click.bind(this));
            li.addEventListener("keyup", this.enter.bind(this));

        }

    }

    // click
    click(e){

        // stop propagation
        e.preventDefault();
        e.stopPropagation();

        // get target
        const header = e.target,

        // header parent
        parent = header.parentNode;

        // end case
        if(!header) return;

        // get arrow
        const arrow = header.querySelector(`span`),

        // get arrow class
        arrowClasses = ((arrow) ? arrow.classList : null),
        
        // get content
        content = parent.querySelector(`.${this.contentClass}`),
        
        // img wrapper 
        img = parent.querySelector(`.${this.imgClass}`),

        // get contet class
        contentClasses = ((content) ? content.classList : null);

        // update arrow
        if(arrowClasses) arrowClasses.contains(`${this.arrowClass}`) ? arrowClasses.remove(this.arrowClass) : arrowClasses.add(this.arrowClass);

        // content
        if(content) contentClasses.contains(`${this.hideClass}`) ? contentClasses.remove(this.hideClass) : contentClasses.add(this.hideClass);
        
        // update tabindex for content and img
        if(content) contentClasses.contains(`${this.hideClass}`) ? content.setAttribute("tabindex", "-1") : content.setAttribute("tabindex", "0");
        if(img) contentClasses.contains(`${this.hideClass}`) ? img.setAttribute("tabindex", "-1") : img.setAttribute("tabindex", "0");

    }

    // on enter
    enter(e){

        // const key = e.key || e.keyCode;
        const key = e.keyCode || e.key.toLowerCase();
        
        // get key 
        if(key === 13 || key === "enter"){

            // run click method
            this.click(e);

        }

    }

}

// export module
export default Terms;